import { FC } from "react"
import styled from "@emotion/styled"

export const Timeline = styled.ul`
  all: unset;
  display: block;
`
